<template>
	<div>
		<navTitle><div class="pageTitle">专家库</div></navTitle>
		<div ref="navTitle" class="navTitle flex flex-align-center" @click.stop :style="{'border': dropdownShow?'none':''}">
			<div ref="navBox" class="navBox flex flex-align-center">
				<div class="navTitle-item" @click="chooseMajor('')" :class="{'navTitle-itemActive': major_id == ''}">全部</div>
				<div :ref="'nav'+item.id" class="navTitle-item" @click="chooseMajor(item.id)" :class="{'navTitle-itemActive': major_id == item.id}" v-for="item in majorList" :key="item.id">{{item.name}}</div>
				<div class="navTitle-station"></div>
			</div>
			
			<div class="navTitle-item" >
				<van-dropdown-menu class="menu">
					<van-dropdown-item ref="dropdownItem" @open="dropdownOpen" @close="dropdownClose">
						<div class="navTitle-dropdown flex flex-align-center flex-jus-between flex-wrap">
							<div @click="chooseMajor('')" class="navTitle-dropdown-item" :class="{'navTitle-dropdown-itemActive': major_id == ''}">全部</div>
							<div @click="chooseMajor(item.id)" v-for="item in majorList" :key="item.id" class="navTitle-dropdown-item" :class="{'navTitle-dropdown-itemActive': major_id == item.id}">{{item.name}}</div>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
			
			<div class="navTitle-arrow flex flex-align-center flex-jus-center" @click="showItem">
				<img src="@/static/images/icon-arrowBottom.png" v-if="!dropdownShow">
				<img src="@/static/images/icon-arrowTop.png" v-else>
			</div>
			
		</div>
		
		<van-list
			v-model="loading"
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<div class="expertList flex flex-align-center flex-jus-between flex-wrap">
				<div class="expertList-item flex flex-column" v-for="(item, index) in dataList" :key="index" @click="$router.push({'name': 'expert_details', 'query': {id: item.id}})">
					<div class="avatar">
						<img :src="item.avatar" alt="">
					</div>
					<div class="name flex flex-align-center flex-jus-between">
						<img src="@/static/images/index/name-left.png" alt="">
						<div class="text flex flex-align-center flex-jus-center">{{item.nickname}}</div>
						<img src="@/static/images/index/name-right.png" alt="">
					</div>
				</div>
			</div>
		</van-list>

		
		
		
	</div>
</template>

<script>
/* eslint-disable */
import {mapState} from 'vuex'
export default {
	data() {
		return {
			dropdownShow: false,
			major_id: '',
			page: 1,
			pageSize: 10,
			dataList: [],
			loading: false,
      finished: false
		};
	},
	computed: {
		...mapState(['majorList'])
	},
	created() {
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '专家库',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getList() {
			this.$get('api/expertUser/getExpertUserList', {
				major_id: this.major_id,
				page: this.page,
				pageSize: this.pageSize
			}).then(res => {
				this.loading = false;
				let rows = res.data
				if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = this.dataList.concat(rows);

				if (this.dropdownShow) {
					this.showItem()
				}
				this.page++
			})
		},
		onLoad() {
      if (this.page > 1) {
        this.getList();
      }
    },
		chooseMajor(id) {
			if (id) {
				console.log(this.$refs['nav'+id][0].offsetLeft)
				this.$refs.navTitle.scrollLeft = this.$refs['nav'+id][0].offsetLeft - 15
			} else {
				this.$refs.navTitle.scrollLeft = 0
			}

			this.major_id = id
			this.page = 1
			this.dataList = []
			this.getList()
		},
		dropdownOpen() {
			this.dropdownShow = true
		},
		dropdownClose() {
			this.dropdownShow = false
		},
		showItem() {
			this.$refs.dropdownItem.toggle()
		}
	}
};
</script>
<style>
	.menu .van-dropdown-item {
		top: 98px!important;
	}
</style>
<style scoped lang="stylus">
.navTitle >>>	.van-dropdown-menu__bar
	visibility hidden
.navTitle
	padding 0 32px
	width 100%
	height 100px
	position fixed
	top 96px
	z-index 101
	background-color #FFFFFF
	overflow-x scroll
	box-sizing border-box
	.navTitle-arrow
		position fixed
		right 0px
		top 96px
		width 86px
		height 100px
		background-color #FFFFFF
		img
			width 24px
			height 14px
	.navTitle-station
		flex 0 0 30px
		height 1px
		background transparent
	.navTitle-item
		font-size 28px
		color #000000
		margin-right 80px
		flex-shrink 0
	.navTitle-itemActive
		font-size 36px
		font-weight 800
		color #DE113C
		position relative
		&::after
			content ' '
			position absolute
			left 0
			bottom -24px
			width 100%
			height 6px
			background #DE113C
	.navTitle-dropdown
		padding 44px 30px
		background-color #FFFFFF
		.navTitle-dropdown-item
			min-width 160px;
			padding 18px 30px
			text-align center
			height: 76px;
			font-size: 28px;
			color: #000000;
			background: #FFFFFF;
			border: 2px solid #B1B1B1;
			border-radius: 38px;
			margin-bottom 12px;
		.navTitle-dropdown-itemActive
			background: #FFD6DF;
			border: 2px solid #DE113C;
			border-radius: 38px;
			font-size: 28px;
			color: #DE113C;
.expertList
	padding 30px
	margin-top 100px
	border-top 4px solid #E2E2E2
	.expertList-item
		margin-bottom 30px
		padding 42px 38px 38px 38px
		background-image url('~@/static/images/index/expertBG.png')
		background-size 100% 100%
		background-position center
		.avatar
			width 248px
			height 320px
			img
				object-fit cover
		.name
			width 100%
			margin-top 18px
			.text
				width 128px
				min-height 80px
				line-height 40px
				text-align center
				font-size: 28px;
				font-weight: bold;
				color: #000000;
			img
				width 50px
				height 20px
</style>
